<template>
  <div>
    <h5 class="mb-1 mt-3">
      {{ $t("disposal-method.periodic") }} <span class="text-muted">({{ $t("common.month") }})</span>
    </h5>

    <input v-model="disposalPeriod" class="form-control" type="number" min="0" max="360" />

    <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
      {{ $t("common.save") }}
    </sweet-button>
  </div>
</template>

<script>
export default {
  props: ["id"],
  components: {},
  data() {
    return {
      disposalPeriod: 0,
    };
  },

  computed: {
    isUpdating() {
      return this.$store.getters["dataDisposalPeriod/isUpdating"];
    },
    //

    editedData() {
      return this.$store.getters["dataDisposalPeriod/editedData"];
    },
  },
  watch: {
    editedData: {
      immediate: true,
      deep: true,
      handler(v) {
        this.disposalPeriod = v?.feature?.disposalPeriod ?? 0;
      },
    },
  },
  mounted() {},
  methods: {
    cancel() {
      this.$store.dispatch("dataDisposalPeriod/resetForm");
    },

    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("dataDisposalPeriod/save", { disposalPeriod: this.disposalPeriod });
        this.$root.$emit("bv::toggle::collapse", this.id);
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    interceptForSetParent(payload) {
      payload.data = this.editedData;
    },
  },
};
</script>
